import React, { useEffect, useState, useContext } from "react";
import {
  CREATE_CONFIGURATION_SURVEY,
  CREATE_SURVEY_TPCLIENT,
  USERS_SURVEY_ACTIVE_USERS,
  UPDATE_NAME_DESCRIPTION_SURVEY_TP,
} from "../../GraphQL/Mutations";
import { ALL_QUESTION_SURVEY } from "../../GraphQL/Queries";
import {
  ButtonWrapper,
  StyleButton,
  ContentCloseButton,
  ContentCommentIcon,
  useStyles,
} from "./SurveyQuestionConfiguration.styled";
import { useMutation, useLazyQuery } from "@apollo/client";
import PubSub from "pubsub-js";
import { uploadFile } from "../../services/FileManager";
import { CloseButton } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { getStateLogin } from "../../containers/LayoutHome/stateLogin";
import { NotificationManager } from "react-notifications";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { Tooltip, withStyles } from "@material-ui/core";
import AddCommentIcon from "@material-ui/icons/AddComment";
import ModalLoader from "../ModalLoader/ModalLoader";
import { theme as themeConfig } from "@themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    background: "rgba(46, 46, 46, 0.2)",
    margin: "2em 0",
    fontSize: "14px",
    color: themeConfig.primary.purple,
  },
}))(Tooltip);

const SurveyQuestionConfiguration = ({
  idSurvey,
  field,
  OnlyAssigned,
  Anonymity,
  RandomQuestions,
  activeSubmittApproval,
  setActiveSubmittApproval,
  setActiveForm,
  onlyReviewWithComments,
  surveyStateId,
  handleComments,
  itsForm = false,
}) => {
  const classes = useStyles();
  const [folderName] = useState("Surveys");
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const [user] = useState(getStateLogin());
  const [createConfigurationSurvey] = useMutation(CREATE_CONFIGURATION_SURVEY);
  const [createSurveyTPClient] = useMutation(CREATE_SURVEY_TPCLIENT);
  const [usersSurveyActiveUsers] = useMutation(USERS_SURVEY_ACTIVE_USERS);
  const [updateSurvey] = useMutation(UPDATE_NAME_DESCRIPTION_SURVEY_TP);
  const [dataSurvey, setDataSurvey] = useState();
  const [wordType, setWordType] = useState(itsForm ? "form" : "survey");
  const [runQuerySurvey] = useLazyQuery(ALL_QUESTION_SURVEY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setDataSurvey({ ...data });
    },
  });
  const [setModulesFromValidateSaveSurvey] = useState([]);
  const [configuration, setObjectConfiguration] = useState([{}]);
  const [, setclosedQuestion] = useState([]);
  const [isIntegrated, setIsIntegrated] = useState(false);
  const history = useHistory();
  const handleOnClick = () => {
    history.push(`/Gamification`);
    setTimeout(() => {
      itsForm
        ? history.push(`/FormsManagement`)
        : history.push(`/ManageSurvey`);
    }, 1);
  };
  const [showLoader, setshowLoader] = useState(false);

  useEffect(() => {
    PubSub.subscribe("modulesFromValidateSaveSurvey", (e, data) => {
      setModulesFromValidateSaveSurvey(data);
    });

    PubSub.subscribe("surveyConfiguration", (e, data) => {
      setObjectConfiguration(data);
    });

    PubSub.subscribe("addClosedQuestion", (e, data) => {
      setclosedQuestion((oldArray) => [...oldArray, data]);
    });

    PubSub.subscribe("removeClosedQuestion", (e, data) => {
      setclosedQuestion((oldArray) => oldArray.filter((item) => item !== data));
    });

    PubSub.subscribe("updateClosedQuestion", (e, data) => {
      setclosedQuestion(data);
    });

    PubSub.subscribe("isIntegrated", (e, data) => {
      setIsIntegrated(data);
    });
    return () => {
      PubSub.unsubscribe("modulesFromValidateSaveSurvey");
      PubSub.unsubscribe("surveyConfiguration");
      PubSub.unsubscribe("addClosedQuestion");
      PubSub.unsubscribe("removeClosedQuestion");
      PubSub.unsubscribe("updateClosedQuestion");
      PubSub.unsubscribe("isIntegrated");
    };
  }, []);

  useEffect(() => {
    if (dataSurvey) {
      const questions = dataSurvey.allQuestionsSurvey; //.filter(i => i.idSurvey === idSurvey);
      const inactiveQuestions = questions.filter((i) => i.active === false);

      if (
        questions.length > 0 &&
        inactiveQuestions.length !== questions.length
      ) {
        saveSurveyQuestion();
      } else {
        setActiveSubmittApproval(false);
        NotificationManager.warning(
          itsForm
            ? "you must set up a question before saving the form"
            : "you must set up a question before saving the survey",
          "",
          5000
        );
      }
    }
  }, [dataSurvey]);

  let existQuestionByIdSurvey = () => {
    if (stateQuestionsReducer.questions.filter((f) => f.GisEdit).length === 0) {
      runQuerySurvey({ variables: { idSurvey: idSurvey } });
    } else {
      let errorMessage = `You have a question pending to be configured. Please save your changes in the question before saving your ${wordType}`;
      NotificationManager.warning(errorMessage, "", 5000);
    }
  };

  let saveSurveyQuestion = () => {
    let files = [];
    configuration.forEach((element) => {
      if (
        element.configurationJson.image &&
        element.configurationJson.image.length
      ) {
        files.push(element.configurationJson.image[0]);
      }
    });
    let fileObj = {};
    if (files.length > 0) {
      setshowLoader(true);
      uploadFile(files, folderName)
        .then((res) => {
          if (res && res?.length && res.length > 0) {
            res = JSON.parse(res);
            res.forEach((e) => {
              fileObj[e.oldName] = e.newName;
            });
            saveSurveyConfig(fileObj);
          } else {
            saveSurveyConfig(fileObj);
            NotificationManager.error(
              "Something went wrong on saving images",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      saveSurveyConfig(fileObj);
    }
  };

  const saveSurveyConfig = (fileObj) => {
    let errorMessage = "";
    let countSend = 0;
    configuration.forEach((element) => {
      if (element?.configurationJson?.nameImage) {
        element.configurationJson.nameImage =
          fileObj[element.configurationJson.nameImage];
      }
      createConfigurationSurvey({
        variables: {
          idSurvey: idSurvey,
          field: element.field,
          jsonConfiguration: JSON.stringify(element.configurationJson),
          createUser: user,
        },
      })
        .then((response) => {
          setshowLoader(false);
          countSend++;
          if (configuration.length === countSend) {
            if (errorMessage === "") {
              if (isIntegrated) {
                createSurveyTPClient({
                  variables: { idSurvey: idSurvey },
                })
                  .then((response) => {
                    if (errorMessage === "") {
                      itsForm
                        ? setActiveForm(true)
                        : setActiveSubmittApproval(true);
                    } else {
                      NotificationManager.error(errorMessage, "", 5000);
                      setActiveSubmittApproval(false);
                    }
                  })
                  .catch((error) => {
                    errorMessage = error.message.split("\n")[0];
                    NotificationManager.error(errorMessage, "", 5000);
                    setActiveSubmittApproval(false);
                  });
              }
              let usersIdParameter = [];
              let surveyGroupIds = [];
              let surveyName = "";
              let surveyDescription = "";
              let surveyTitle = "";
              configuration.forEach((resp) => {
                if (resp.field === "SelectedUsers") {
                  resp.configurationJson.users.forEach((element) => {
                    usersIdParameter.push(element.value);
                  });
                }
                if (resp.field === "SurveyGroupIds") {
                  resp.configurationJson.groups.forEach((group) => {
                    surveyGroupIds.push(group);
                  });
                }
                if (resp.field === "surveyName") {
                  surveyName = resp.configurationJson.text;
                }
                if (resp.field === "surveyDescription") {
                  surveyDescription = resp.configurationJson.text;
                }
                if (resp.field === "Title") {
                  surveyTitle = resp.configurationJson.text;
                }
              });
              let emailUser = getStateLogin();
              if (idSurvey && user) {
                if (!surveyName) {
                  NotificationManager.warning(
                    "Please type a Name for your survey before saving",
                    "",
                    5000
                  );
                  setActiveSubmittApproval(false);
                } else if (!surveyDescription) {
                  NotificationManager.warning(
                    "Please type a Description for your survey before saving",
                    "",
                    5000
                  );
                  setActiveSubmittApproval(false);
                } else if (!surveyTitle || surveyTitle === "<p></p>\n") {
                  NotificationManager.warning(
                    "Please type a Title for your survey before saving",
                    "",
                    5000
                  );
                  setActiveSubmittApproval(false);
                } else if (
                  surveyName !== "" ||
                  surveyDescription !== "" ||
                  surveyTitle !== ""
                ) {
                  updateSurvey({
                    variables: {
                      idSurvey: idSurvey,
                      surveyName: surveyName,
                      surveyDescription: surveyDescription,
                      isAnonymous: Anonymity,
                      setRandomQuestions: RandomQuestions,
                      lastUpdateUser: user,
                    },
                  })
                    .then((response) => {
                      if (response.data.updateSurvey) {
                        itsForm
                          ? setActiveForm(true)
                          : setActiveSubmittApproval(true);
                      } else {
                        NotificationManager.warning(errorMessage, "", 5000);
                        setActiveSubmittApproval(false);
                      }
                    })
                    .catch((error) => {
                      errorMessage = error.message.split("\n")[0];
                      NotificationManager.error(errorMessage, "", 5000);
                      setActiveSubmittApproval(false);
                    });
                  usersSurveyActiveUsers({
                    variables: {
                      activeParameter: true,
                      surveyIdParameter: idSurvey,
                      emailUser: emailUser,
                      usersIdParameter: usersIdParameter,
                      surveyGroupIds: surveyGroupIds,
                    },
                  })
                    .then((response) => {
                      if (response.data.usersSurveyActiveUsers) {
                        itsForm
                          ? setActiveForm(true)
                          : setActiveSubmittApproval(true);
                      } else {
                        setActiveForm(false);
                        NotificationManager.warning(errorMessage, "", 5000);
                        setActiveSubmittApproval(false);
                      }
                    })
                    .catch((error) => {
                      errorMessage = error.message.split("\n")[0];
                      NotificationManager.error(errorMessage, "", 5000);
                      setActiveSubmittApproval(false);
                    });
                  let successMessage = `Your ${wordType} has been saved successfully`;
                  NotificationManager.success(successMessage, "", 5000);
                }
              } else {
                NotificationManager.warning("Error 404", "", 5000);
                setActiveSubmittApproval(false);
              }
            } else {
              NotificationManager.warning(errorMessage, "", 5000);
              setActiveSubmittApproval(false);
            }
          }
        })
        .catch((error) => {
          errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setActiveSubmittApproval(false);
        });
    });
  };

  return (
    <ButtonWrapper OnlyAssigned={OnlyAssigned} surveyStateId={surveyStateId}>
      {(surveyStateId === 7 || surveyStateId === 6) &&
        surveyStateId &&
        surveyStateId !== 5 && (
          <ContentCommentIcon surveyStateId={surveyStateId}>
            <HtmlTooltip
              arrow
              placement="bottom"
              title={
                "You have comments for your survey left by your approver, please take a look before submit to approve"
              }
            >
              <AddCommentIcon
                className={classes.commentIconStyle}
                onClick={() => handleComments()}
                style={{ transform: "scaleX(-1)" }}
              />
            </HtmlTooltip>
          </ContentCommentIcon>
        )}
      {itsForm ? (
        <StyleButton
          isNotDisabled={
            (surveyStateId === 5 && !onlyReviewWithComments) ||
            (surveyStateId === 6 && !onlyReviewWithComments)
          }
          disabled={surveyStateId === 6 && !onlyReviewWithComments}
          type="submit"
          onClick={() => {
            if (
              (!onlyReviewWithComments && surveyStateId !== 6) ||
              surveyStateId === 1
            ) {
              existQuestionByIdSurvey();
            }
          }}
        >
          Save Form
        </StyleButton>
      ) : (
        <StyleButton
          isNotDisabled={
            (surveyStateId === 5 && !onlyReviewWithComments) ||
            (surveyStateId === 6 && !onlyReviewWithComments)
          }
          disabled={surveyStateId === 6 && !onlyReviewWithComments}
          type="submit"
          onClick={() => {
            if (
              (!onlyReviewWithComments && surveyStateId !== 6) ||
              surveyStateId === 1
            ) {
              existQuestionByIdSurvey();
            }
          }}
        >
          Save Survey
        </StyleButton>
      )}
      <ContentCloseButton onClick={() => handleOnClick()}>
        <CloseButton className="text-light mb-1"></CloseButton>
      </ContentCloseButton>
      {showLoader && <ModalLoader></ModalLoader>}
    </ButtonWrapper>
  );
};

export default SurveyQuestionConfiguration;
